module.exports = __webpack_public_path__ + "static/media/artwork_15.aeb55a67.png";